export default "__VITE_ASSET__BtpJq4R1__"